import { render, staticRenderFns } from "./PageItemsGroup.vue?vue&type=template&id=4836da70&"
import script from "./PageItemsGroup.vue?vue&type=script&lang=js&"
export * from "./PageItemsGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports